import paceHistory from '../data/pace_history.json';

// Slår ihop statisk pace-historik (arken) med automatiska veckosnapshots
// (intel_pace_live via getBelaggning). Live-rader ersätter samma asOf.
export function mergeSeasons(paceLive) {
  const out = {};
  for (const sid of Object.keys(paceHistory.seasons || {})) {
    const s = paceHistory.seasons[sid];
    out[sid] = { typ: s.typ, rumKapacitet: s.rumKapacitet, snapshots: [...(s.snapshots || [])], rows: [...(s.rows || [])] };
  }
  const weeks = (paceLive && paceLive.weeks) || {};
  for (const key of Object.keys(weeks)) {
    const snap = weeks[key]; const asOf = snap && snap.asOf; if (!asOf) continue;
    for (const sid of Object.keys(snap.seasons || {})) {
      if (!out[sid]) out[sid] = { typ: sid.startsWith('vinter') ? 'vinter' : 'sommar', rumKapacitet: 45, snapshots: [], rows: [] };
      out[sid].rows = out[sid].rows.filter(r => r.asOf !== asOf)
        .concat((snap.seasons[sid] || []).map(r => ({ asOf, week: r.week, bel: r.bel, gastn: r.gastn, rumsn: r.rumsn, varde: r.varde, logi: r.logi, mat: r.mat })));
      if (!out[sid].snapshots.includes(asOf)) out[sid].snapshots.push(asOf);
    }
  }
  for (const sid of Object.keys(out)) out[sid].snapshots.sort();
  return out;
}
